import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class FaqService {
  private base_url = `http://abotallal.tech`;
  constructor(private _HttpClient: HttpClient) { }
  getQuestion(): Observable<any> {
    return this._HttpClient.get<any>(`${this.base_url}/api/admin/question_index`)
  }
}
